import { localStorage } from 'window'

export default class Store {
  static init (data) {
    localStorage.setItem('jiminny-extension-app', JSON.stringify(data))
  }
  static data () {
    return JSON.parse(localStorage.getItem('jiminny-extension-app') || '{}')
  }
  static get (key) {
    return this.data()[key]
  }
  static set (key, value) {
    const data = this.data()
    data[key] = value
    this.init(data)
  }
  static setBulk (bulkData) {
    const data = this.data()
    for (const key of Object.keys(bulkData)) {
      data[key] = bulkData[key]
    }
    this.init(data)
  }
  static delete (key) {
    const data = this.data()
    delete data[key]
    this.init(data)
  }
  static truncate () {
    localStorage.removeItem('jiminny-extension-app')
  }
}



// WEBPACK FOOTER //
// ./src/lib/store.js